var common = require('./common')

jQuery(function($) {
  console.log("%cStop !", "font-family:helvetica; font-size:50px; font-weight:bold; color:red; -webkit-text-stroke:1px black;")
  console.log("")
  console.log("%" + Drupal.t("cIl s’agit d’une fonctionnalité de navigateur conçue pour les développeurs. Si quelqu’un vous a invité(e) à copier-coller quelque chose ici pour activer une fonctionnalité ou soit-disant pirater le compte d’un tiers, sachez que c’est une escroquerie permettant à cette personne d’accéder à votre compte."), "font-family:helvetica; font-size:20px;")

  if ( window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD )
  {
    if ( window.location.pathname == '/les-publications' )
    {
      window.location.reload();
    }
  }

  // Same height
  $('.row-eq-height-item').matchHeight()

  // Select to dropdown
  $('.selectpicker').selectpicker()

  // Share popup links
  $('.popup-share').on('click', function(e) {
    $(this).customerPopup(e, 640, 480, 'yes');
  })

  // Remove links forum
  $('.forum-th-default > a, .forum-body .st-key > a').on('click', function(e) {
    e.preventDefault()
  })

  // Filters of views
  $('.reset-button').on('click', function(e) {
    e.preventDefault()
    $('.filters-set__btn').removeClass('active')
    $('.filters-exposed option:selected').prop('selected', false)

    fillIdsForExclude()
    resetSliderYears()

    RecallAjax.view('reset')
  })

  var resetSliderYears = function()
  {
    var slider_instance = $('#slider__year_of_release').data('ionRangeSlider');
    slider_instance.update({
      from: $('#slider__year_of_release').data('min'),
      to: $('#slider__year_of_release').data('max')
    });
  }

  var fillIdsForExclude = function()
  {
    if ( $('.views-view--generic #edit-nid-1a').length > 0 )
    {
      $('.views-view--generic #edit-nid-1a').val($('.views-view--generic #filter_nid_1a').val())
      $('.views-view--generic #edit-nid-1b').val($('.views-view--generic #filter_nid_1b').val())
      $('.views-view--generic #edit-nid-2a').val($('.views-view--generic #filter_nid_2a').val())
      $('.views-view--generic #edit-nid-2b').val($('.views-view--generic #filter_nid_2b').val())
      $('.views-view--generic #edit-nid-3a').val($('.views-view--generic #filter_nid_3a').val())
      $('.views-view--generic #edit-nid-3b').val($('.views-view--generic #filter_nid_3b').val())
    }
  }

  // Search input filter
  $('#field_volume__filter_view, #field_fascicle__filter_view').on('keyup', function(e) {
    e.preventDefault();
    $('.filters-exposed [name="' + $(this).data('field') + '"]').val($(this).val());
    RecallAjax.view('reset');
  });

  $('#pubSearchSubmit').on('click', function(e) {
    e.preventDefault()
    $('.filters-exposed [name="search"]').val($('#pubSearchField').val())

    RecallAjax.view('reset')
  })

  if ( $('.views-view--generic #edit-date').length > 0 )
  {
    var dateObj = new Date()
    var month   = dateObj.getUTCMonth() + 1 // months from 1-12
    var day     = dateObj.getUTCDate()
    var year    = dateObj.getUTCFullYear()

    $('.views-view--generic #edit-date').val(year + '-' + month + '-' + day)
    $('.views-view--generic #edit-date-end').val(year + '-' + month + '-' + day)
    $('.views-view--generic #edit-date-end-1').val(year + '-' + month + '-' + day)
    $('#edit-sort-by option[value="field_date"]').prop('selected', true)
    $('#edit-sort-order option[value="ASC"]').prop('selected', true)

    fillIdsForExclude()

    RecallAjax.view('reset')
  }

  // Dropdown filters
  $('.dropdown-menu-filter').on('click', 'li a', function() {
    $('.dropdown-menu-filter').find('.sorting-dropdown__text').text($(this).text())

    if ( $(this).data('sort_by') == 'from_today' )
    {
      var dateObj = new Date()
      var month   = dateObj.getUTCMonth() + 1 // months from 1-12
      var day     = dateObj.getUTCDate()
      var year    = dateObj.getUTCFullYear()

      $('#edit-sort-by option[value="field_date"]').prop('selected', true)
      $('#edit-date').val(year + '-' + month + '-' + day)
      $('#edit-date-end').val(year + '-' + month + '-' + day)
      $('#edit-date-end-1').val(year + '-' + month + '-' + day)
    }
    else
    {
      $('#edit-sort-by option[value="' + $(this).data('sort_by') + '"]').prop('selected', true)
      $('#edit-date').val('')
      $('#edit-date-end').val('')
      $('#edit-date-end-1').val('')
    }
    $('#edit-sort-order option[value="' + $(this).data('sort_order') + '"]').prop('selected', true)

    fillIdsForExclude()

    RecallAjax.view('reset')
  })

  $('.filters__panel-nobtn').on('click', function(e) {
    e.preventDefault()
  })

  // View infinite scroll
  if ( $('.view__results_content').length > 0 )
  {
    var win = $(window)
    win.scroll(function()
    {
      var limit = $('.view__results_content').height() - 100
      if ( win.scrollTop() >= limit )
      {
        RecallAjax.view('load-more')
      }
    })
  }

  // Sticky Devenez adhérent
  if ( $('#become-member--sticky').length > 0 )
  {
    var cookie = readCookie('become_member_sticky')
    if ( !cookie )
    {
      if ( $('body').hasClass('is_not_member') )
      {
        var time = 15000
        var selectorSticky = document.querySelector('script[type="application/json"][data-drupal-selector="drupal-settings-smf-json"]')
        if ( selectorSticky )
        {
          var settingsSticky = JSON.parse(selectorSticky.textContent)
          time = settingsSticky.time_adherent_sticky * 1000
        }

        var adherent = setInterval(function() {
          $('#become-member--sticky').fadeIn('slow')
          clearInterval(adherent)
        }, time)
      }
    }

    $('.become-member--btn-close').on('click', function(e) {
      e.preventDefault()
      $('#become-member--sticky').fadeOut('slow')
      createCookie('become_member_sticky', 'closed', 1)
    })
  }

  // Extra fields
  if ( $('.extra-fields').length > 0 )
  {
    var html = $('.extra-fields').html()
    $('.extra-fields').remove()
    $('.article-body__main-title').first().after(html)
  }

  fnCarouselHome.init()
  fnTabsPublications.init()

  // Clean legende line
  $('.imagelegende_container--content-text').each(function() {
    var text = $(this).text()
    if ( text.trim() == '' )
    {
      $(this).addClass('no-line')
    }
  })

  // Change input text in recovery password
  var drupal_current_language = 'fr';
  if ( drupalSettings.path.currentQuery != undefined )
  {
    drupal_current_language = drupalSettings.path.currentQuery.language;
  }
  else if ( drupalSettings.path.currentLanguage )
  {
    drupal_current_language = drupalSettings.path.currentLanguage;
  }

  if ( drupal_current_language == 'fr' )
  {
    var submit_text = Drupal.t('Soumettre');
  }
  else
  {
    var submit_text = 'Send';
  }
  $('#user-pass input[type="submit"]').val(submit_text);

  // Special style for images with legend with align center
  if ( $('.imagelegende_container--content-text').length > 0 )
  {
    $('.imagelegende_container--content-text').prev('p[style*="text-align:center"]').closest('figure').css('display', 'table')
    $('.imagelegende_container--content-text').prev('p[style*="text-align:center"]').closest('figure').css('margin', '0 auto')
  }

  // Scroll to in publications view
  if ( $('#wrapper-publications-search').length > 0 )
  {
    var url = proxyLoc(window.location).href
    if (url.match(/\?./))
    {
      var st = $('#wrapper-publications-search').offset().top
      if ( $('.wrapper-header').length > 0 )
      {
        st -= $('.wrapper-header').outerHeight()
      }

      if ( $('#toolbar-bar').length > 0 )
      {
        st -= $('#toolbar-bar').outerHeight()
      }

      $('html,body').animate({scrollTop: st}, '1000');
    }
  }

  // Slider publications view
  if ( $('#slider__year_of_release').length > 0 )
  {
    $('#slider__year_of_release').ionRangeSlider({
      skin: "flat",
      onStart: function (data) { },
      onChange: function (data) { },
      onFinish: function (data)
      {
        $('.slider__year_of_release_container .filters-set__btn').removeClass('active')
        $('.filters-exposed select[name="field_year_of_release[]"]').val('')
        $('.filters-exposed select[name="field_year_of_release[]"] option').prop('selected', false)

        for (var i = data.from; i <= data.to; i++)
        {
          $('.filters-exposed option[value="' + $('.slider__year_of_release_container .filters-set__btn[data-name="' + i + '"]').data('fid') + '"]').prop('selected', true)
        }

        RecallAjax.view('reset')

        common.dataLayerPush({
          'event'      : 'GAEvent',
          'eventAction': 'Click',
          'eventLabel' : Drupal.t('Sélection des années'),
          'eventValue' : data.from + ' - ' + data.to,
          'eventPage'  : proxyLoc(window.location).href
        })
      },
      onUpdate: function (data) { }
    });
  }

  if ( drupal_current_language == 'fr' )
  {
    var adv = '<p>' + Drupal.t("J'accepte que mes données personnelles soient utilisées par la Société Mathématique de France selon les règles définies dans la <a href=\"/la-smf/politique-de-donnees-personnelles\">politique de confidentialité</a> du site.") + '</p>';
  }
  else
  {
    var adv = '<p>' + Drupal.t("I agree that my personal data will be used by Société Mathematique de France according to the rules defined in the site's <a href=\"/la-smf/politique-de-donnees-personnelles\">privacy policy</a>.") + '</p>';
  }
  $(adv).insertAfter('.user-register-form #edit-field-user-tiers-adherent-list-wrapper')


  var is_je_suis = ( window.location.pathname == '/je-suis' ? true : false )
  if ( is_je_suis )
  {
    var je_suis_txt = $('h1.article-body__main-title').text()
    var profile     = common.getURLParameter('profile')
    je_suis_txt     = je_suis_txt + ' ' + decodeURI(profile)
    $('h1.article-body__main-title').text(je_suis_txt)
  }

  // Start GTM
  var u       = proxyLoc(window.location).protocol + '//' + proxyLoc(window.location).host
  var dataGTM = {}

  $('body').on('click', '.gtm-btn', function(e) {
    var data = $(this).data('gtm')
    common.dataLayerPush({
      'event'      : 'GAEvent',
      'eventAction': data.action,
      'eventLabel' : data.label,
      'eventValue' : data.value,
      'eventPage'  : data.page
    })
  })

  $(window).scroll(function() {
    common.dataLayerPush({
      'event'            : 'ScrollDepthEvent',
      'scrollDepthAction': 'Scroll',
      'scrollDepthValue' : $(window).scrollTop(),
      'scrollDepthPage'  : proxyLoc(window.location).href
    })
  })

  if ( $('.become-member__btn').length > 0 )
  {
    dataGTM = {
      action  : 'Click',
      label   : Drupal.t('DEVENIR ADHÉRENT'),
      value   : u + $('.become-member__btn').attr('href'),
      page    : proxyLoc(window.location).href,
    }
    $('.become-member__btn').addClass('gtm-btn').addClass('gtm-btn-js').attr('data-gtm', JSON.stringify(dataGTM))
  }

  if ( $('.twitter-slider').length > 0 )
  {
    setTimeout(function() {
      dataGTM = {
        action  : 'Click',
        label   : Drupal.t('Passer au tweet précédent'),
        value   : '<',
        page    : proxyLoc(window.location).href,
      }
      $('.twitter-carrousel__button__previous .twitter-carrousel__button__button').addClass('gtm-btn').addClass('gtm-btn-js').attr('data-gtm', JSON.stringify(dataGTM))

      dataGTM = {
        action  : 'Click',
        label   : Drupal.t('Passer au tweet suivant'),
        value   : '>',
        page    : proxyLoc(window.location).href,
      }
      $('.twitter-carrousel__button__next .twitter-carrousel__button__button').addClass('gtm-btn').addClass('gtm-btn-js').attr('data-gtm', JSON.stringify(dataGTM))
    }, 10000)
  }

  if ( $('#filters-accordion').length > 0 )
  {
    $('#filters-accordion .filters-set__btn').on('click', function(){
      var label = 'Sélection du filtre'
      if ( $(this).hasClass('active') )
      {
        label = Drupal.t('Désélection du filtre')
      }

      var value = $(this).text()
      value = value.replace(/[\r\n]+/g, '')

      common.dataLayerPush({
        'event'      : 'GAEvent',
        'eventAction': 'Click',
        'eventLabel' : label,
        'eventValue' : value,
        'eventPage'  : proxyLoc(window.location).href
      })
    })

    $('.filters__panel-btn').on('click', function(){
      var label = Drupal.t('Fermeture du groupe de filtres')
      if ( $(this).hasClass('collapsed') )
      {
        label = Drupal.t("Filtres de groupe d'ouverture")
      }

      var value = $(this).text()
      value = value.replace(/[\r\n]+/g, '')

      common.dataLayerPush({
        'event'      : 'GAEvent',
        'eventAction': 'Click',
        'eventLabel' : label,
        'eventValue' : value,
        'eventPage'  : proxyLoc(window.location).href
      })
    })
  }

  if ( $('.accordion_link').length > 0 )
  {
    $('.accordion_link').on('click', function(){
      var label = Drupal.t('Masquer le contenu')
      if ( $(this).hasClass('collapsed') )
      {
        label = Drupal.t('Afficher le contenu')
      }

      var value = $(this).find('.data-french').text()
      value = value.replace(/[\r\n]+/g, '')

      common.dataLayerPush({
        'event'      : 'GAEvent',
        'eventAction': 'Click',
        'eventLabel' : label,
        'eventValue' : value,
        'eventPage'  : proxyLoc(window.location).href
      })
    })
  }

  if ( $('a, button, input[type="submit"]').length > 0 )
  {
    $('a, button, input[type="submit"]').each(function() {
      if ( !$(this).hasClass('gtm-btn') && !$(this).hasClass('filters-set__btn') && !$(this).hasClass('filters__panel-btn') && !$(this).hasClass('accordion_link') )
      {
        var label = ''

        if ( $(this).is('input[type="submit"]') )
        {
          label = $(this).val()
        }
        else if ( $(this).hasClass('download') )
        {
          label = $(this).find('span.download__title').text()
        }
        else if ( $(this).hasClass('.page_sommaire__block-link') )
        {
          label = $(this).find('h2').text()
        }
        else
        {
          label = $(this).text()
        }

        label = label.replace(/[\r\n]+/g, '').trim()

        var href = $(this).attr('href')
        if ( href === undefined || href === false || href == 'undefined' )
        {
          href = 'javascript:;'
        }

        dataGTM = {
          action  : 'Click',
          label   : label,
          value   : ( href.search("http://") == -1 &&
                      href.search("http://") == -1 &&
                      href.search("mailto:") == -1 &&
                      href.search("javascript:;") == -1
                        ? u + $(this).attr('href') : $(this).attr('href') ),
          page    : proxyLoc(window.location).href,
        }
        $(this).addClass('gtm-btn').addClass('gtm-btn-js').attr('data-gtm', JSON.stringify(dataGTM))
      }
    })
  }

  if ( $('.article-body.edito').length > 0 )
  {
    $('.article-body.edito input').each(function() {
      if ( !$(this).hasClass('gtm-btn') )
      {
        dataGTM = {
          action  : 'Click',
          label   : $(this).attr('type'),
          value   : $(this).closest('form').attr('action'),
          page    : proxyLoc(window.location).href,
        }
        $(this).addClass('gtm-btn').addClass('gtm-btn-js').attr('data-gtm', JSON.stringify(dataGTM))
      }
    })
  }
  // End GTM

  if ( $('.dashboard-page-section').length > 0 )
  {
    $('#block-smf-local-tasks').remove()
  }

  setTimeout(function() {
    $('#block-smf-local-tasks').addClass('dbi')
  }, 2000)


  // Fixed in views
  var fviews = [
    '/archives',
    '/les-publications',
    '/offres-speciales',
    '/dossiers-et-ressources',
    '/evenements',
    '/actualites',
    '/je-suis',
    '/recherche'
  ];
  var r = fviews.indexOf(window.location.pathname);
  if ( r != -1 )
  {
    var w              = $('.wrapper-return-top');
    var wr             = $('.wrapper-return-top .return-top');
    var w_y            = w.position().top;
    var elementTop     = w.offset().top;
    var elementBottom  = elementTop + w.outerHeight();
    var viewportTop    = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    $(window).scroll(function()
    {
      w_y            = w.position().top;
      elementTop     = w.offset().top;
      elementBottom  = elementTop + w.outerHeight();
      viewportTop    = $(window).scrollTop();
      viewportBottom = viewportTop + $(window).height();

      if ( (elementBottom > viewportTop && elementTop < viewportBottom) || $(window).scrollTop() >= w_y )
      {
        wr.css({
          'position': 'relative',
          'bottom': 0,
        })
      }
      else
      {
        wr.css({
          'position': 'fixed',
          'bottom': 0,
        })
      }
    });
  }
})


// WEBPACK FOOTER //
// ./js/main.js